export type Flags = {
  ['agency-medical-history-update-survey']: boolean;
  ['agency-site-intro-offer-banner-copy']: boolean;
  ['agency-small-bottles-in-sign-up']: boolean;
  ['agency-recognize-email-skin']: boolean;
  ['agency-rebrand']: boolean;
  ['curology-account-creation-save-progress']: boolean;
  ['curology-celebrity-launch']: boolean;
  ['curology-gift-with-purchase']: boolean;
  ['curology-hydro-plus-cleanser-and-moisturizer']: boolean;
  ['curology-medical-history-update-survey']: boolean;
  ['curology-new-recommendations-logic']: boolean;
  ['curology-recognize-email-hair']: boolean;
  ['curology-recognize-email-skin']: boolean;
  ['curology-resubscription-alternate-copy']: boolean;
  ['curology-resubscription-edit-products']: boolean;
  ['curology-site-intro-offer-banner-copy']: boolean;
  ['curology-1-x-rx-in-resub']: boolean;
  ['express-curology-sign-up-skin']: boolean;
  ['shopify-signup']: boolean;
  ['show-preferred-language']: boolean;
};

export const defaultFlagValues: Partial<Flags> = {
  ['agency-medical-history-update-survey']: false,
  ['agency-site-intro-offer-banner-copy']: false,
  ['agency-small-bottles-in-sign-up']: false,
  ['agency-recognize-email-skin']: false,
  ['agency-rebrand']: false,
  ['curology-account-creation-save-progress']: false,
  ['curology-celebrity-launch']: false,
  ['curology-new-recommendations-logic']: true,
  ['curology-gift-with-purchase']: false,
  ['curology-hydro-plus-cleanser-and-moisturizer']: false,
  ['curology-medical-history-update-survey']: false,
  ['curology-recognize-email-hair']: false,
  ['curology-recognize-email-skin']: false,
  ['curology-resubscription-alternate-copy']: false,
  ['curology-resubscription-edit-products']: false,
  ['curology-site-intro-offer-banner-copy']: false,
  ['curology-1-x-rx-in-resub']: false,
  ['express-curology-sign-up-skin']: false,
  ['shopify-signup']: false,
  ['show-preferred-language']: false,
} as const;

export const jsonFlagValues: (keyof Flags)[] = [];
